import {
  useModalContext,
  WSButton,
  WSButtons,
  WSElementProps,
  WSForm,
  WSModal
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { useUpdateCollaborator } from "../../../query/payments/mutations";
import {
  useCollaboratorQuery,
  useListCollaboratorSettingsAdditionalData
} from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import {
  getDefaultValuesForAdditionalData,
  getYupValidationSchema,
  prepareCollaboratorLabelsRequest
} from "../../../utils/jsonFormSchema";
import { prepareDynamicFormFields } from "../AddCollaboratorForm/AddCollaboratorForm";

type Props = WSElementProps & { collaboratorId: string };

export const EDIT_COLLABORATOR_ADDITIONAL_INFO_MODAL =
  "EDIT_COLLABORATOR_ADDITIONAL_INFO_MODAL";

export const EditCollaboratorAdditionalInfoModal: React.FC<Props> = ({
  collaboratorId
}) => {
  const collaboratorQuery = useCollaboratorQuery(collaboratorId);
  const [updateCollaborator, updateCollaboratorMeta] = useUpdateCollaborator(
    collaboratorId
  );
  const { closeModal } = useModalContext();
  const collaboratorSettingsAdditionalDataQuery = useListCollaboratorSettingsAdditionalData();

  return (
    <WSModal
      name={EDIT_COLLABORATOR_ADDITIONAL_INFO_MODAL}
      size="S"
      title="Custom fields"
    >
      <WSQueries
        queries={{ collaboratorQuery, collaboratorSettingsAdditionalDataQuery }}
      >
        {({
          collaboratorQuery: { data: collaborator },
          collaboratorSettingsAdditionalDataQuery: { data: additionalData }
        }) => {
          const additionalDataValidationSchema = getYupValidationSchema(
            additionalData
          );

          return (
            <WSForm
              defaultValues={getDefaultValuesForAdditionalData(
                additionalData,
                (collaborator as any).labels
              )}
              onSubmit={values => {
                updateCollaborator(
                  {
                    labels: prepareCollaboratorLabelsRequest(
                      additionalData,
                      values
                    )
                  },
                  {
                    onSuccess: () => {
                      closeModal(EDIT_COLLABORATOR_ADDITIONAL_INFO_MODAL);
                    }
                  }
                );
              }}
              validationSchema={Yup.object().shape({
                ...additionalDataValidationSchema
              })}
            >
              {prepareDynamicFormFields(additionalData)}

              <WSErrorMessage
                mb="M"
                error={updateCollaboratorMeta.error}
                contextKey="EditContact"
              />

              <WSButtons format="modal">
                <WSButton loading={updateCollaboratorMeta.isLoading}>
                  Update
                </WSButton>
                <WSButton.Tertiary
                  onClick={() => {
                    closeModal(EDIT_COLLABORATOR_ADDITIONAL_INFO_MODAL);
                  }}
                >
                  Cancel
                </WSButton.Tertiary>
              </WSButtons>
            </WSForm>
          );
        }}
      </WSQueries>
    </WSModal>
  );
};
